module.exports = __webpack_public_path__ + "img/logo-icon.832cafab.svg";